import {
  renderConfigLogoDefaultState,
  type RenderConfigLogoSize,
} from "@memento/types/render-config";
import { type SetEditor } from "src/components/Renderer/RendererProvider";

export type UseBrandingType = ReturnType<typeof useBranding>;

export const useBranding = (setEditor: SetEditor) => {
  function setLogoEnabled(enabled: boolean) {
    setEditor((prev) => ({
      ...prev,
      logo: {
        ...prev.logo,
        enabled,
      },
    }));
  }

  function setLogoSize(size: RenderConfigLogoSize) {
    setEditor((prev) => ({
      ...prev,
      logo: {
        ...prev.logo,
        size,
      },
    }));
  }

  function resetLogoDefaults() {
    setEditor((prev) => ({
      ...prev,
      logo: renderConfigLogoDefaultState,
    }));
  }

  // while this is technically not a logo function, it's related.
  function toggleShowBrandingDuringOutro() {
    setEditor((prev) => ({
      ...prev,
      branding: {
        ...prev.branding,
        enabled: !prev.branding.enabled,
      },
    }));
  }

  return {
    setLogoEnabled,
    setLogoSize,
    resetLogoDefaults,
    toggleShowBrandingDuringOutro,
  };
};
